import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FireflyListModule } from '../../lists/list.module';
import { MobileSortingModalComponent } from './mobile-sorting-modal.component';

@NgModule({
  imports: [CommonModule, FireflyListModule],
  declarations: [MobileSortingModalComponent],
  exports: [MobileSortingModalComponent]
})
export class FireflyMobileSortingModalModule {}
